import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import { PurchaseOrderList } from '../../components/Admin/Inventory/PurchaseOrders';

export default function PurchaseOrdersPage() {
  return (
    <ModuleLayout>
      <PurchaseOrderList />
    </ModuleLayout>
  );
}
